import { instantsInterceptor, } from '@/api/index';

function goDownloadFile(fileId) {
    return instantsInterceptor.get('/service/file/download/' + fileId, {
        responseType: 'blob'
    });
}

function deleteFile(file) {
    return instantsInterceptor.post('/service/file/delete', file);
}



export { goDownloadFile, deleteFile };